import axios from 'axios';
import store from '../../store';

export default {
	findDays(from, to) {
		return axios.get(`/api/days?from=${from}&to=${to}&sort=date`);
	},
	findDuties(from, to) {
		return axios.post(`/api/duties/days`, { from, to });
	},
	findDutiesForDrivers(from, to, drivers, reduced, skipVirtuals) {
		return axios.post(`/api/duties/users`, { from, to, users: drivers, reduced, skipVirtuals });
	},
	async findDutiesWithRootID(rootID) {
		try {
			const result = await axios.get(`/api/duties/root?rootId=${rootID}`);
			return result;
		} catch (err) {
			return err;
		}
	},
	findDuty(dutyId) {
		return axios.get(`/api/duties/${dutyId}`);
	},
	findDutyWithExchanges(dutyId) {
		return axios.get(`/api/duties/${dutyId}?loadExchanges=true`);
	},
	findDutyActivities(dutyId) {
		return axios.get(`/api/duties/${dutyId}/dutyactivities`);
	},
	findAbsence(absenceId) {
		return axios.get(
			`/api/absences/${absenceId}?fields=user,startDate,startTime,endDate,endTime,entireDay,repeating,type,description,status,deleted,deletedAt,deletedBy,createdBy,updatedBy,priority`
		);
	},
	findAllAbsences() {
		return axios.get(
			`/api/absences?fields=user,startDate,startTime,endDate,endTime,entireDay,repeating,type,description,status,deleted,deletedAt,deletedBy,createdBy,updatedBy,priority`
		);
	},
	findAbsences(from, to, user) {
		return axios.get(
			`/api/absences?from=${from}&to=${to}&user=${user.id}&fields=user,startDate,startTime,endDate,endTime,entireDay,repeating,type,description,status,deleted,deletedAt,deletedBy,createdBy,updatedBy,priority`
		);
	},
	async findRecentDuties() {
		return axios.get('/api/duties/recent');
	},
	async createDuty(duty) {
		try {
			const result = await axios.post(`/api/duties`, duty);
			return result;
		} catch (err) {
			return err;
		}
	},
	async deleteDuty({ dutyId, changeComment }) {
		try {
			const result = await axios.delete(`/api/duties/${dutyId}`, {
				data: {
					changeComment,
				},
			});
			return result;
		} catch (err) {
			return err;
		}
	},
	async updateDuty(dutyId, payload) {
		try {
			const result = await axios.patch(`/api/duties/${dutyId}`, payload);
			return result;
		} catch (err) {
			return err;
		}
	},
	async updateRootDuties(duties) {
		try {
			const result = await axios.patch(`/api/duties`, duties);
			return result;
		} catch (err) {
			return err;
		}
	},
	async splitDuty(dutyId, splitBreak, changeComment) {
		return axios.patch(`/api/duties/${dutyId}/split`, {
			splitBreak,
			changeComment: changeComment || undefined,
		});
	},

	async mergeDuty(dutyToMerge, targetDuty, changeComment) {
		return axios.patch(`/api/duties/${dutyToMerge}/merge`, { id: targetDuty, changeComment: changeComment || undefined });
	},
	evaluateSingleDriver(driverId, from, to, debug) {
		return axios.post('/api/roster/evaluateSingleDriver', { driver: driverId, from, to, debug });
	},
	loadStatistics(date, users) {
		return axios.post('/api/statistics', { from: date, to: date, users: users });
	},
	dutyTemplateList({ deleted, excludeProvider }) {
		return axios.get(`/api/duties/template?deleted=${deleted}&excludeProvider=${excludeProvider}`);
	},
	loadStatisticsByDayStatus(dayStatus) {
		return axios.get('/api/statistics/dayStatus/' + dayStatus);
	},
	loadUnallocatedDuties(days) {
		return axios.post('/api/duties/unallocated', { days: days });
	},
	loadUnallocatedUsers(days) {
		return axios.post('/api/users/unallocated', { days: days });
	},
	loadExtraPayCurrency() {
		return axios.get('/api/setup/extraPay_currency');
	},
	loadDeletedDutiesChunk(chunk) {
		return axios.get('/api/duties/deleted/' + chunk);
	},
	restoreDuty(dutyId) {
		return axios.patch('/api/duties/restore/' + dutyId);
	},
	addToExchange(data) {
		return axios.post('/api/exchange', data);
	},
	loadAgreements(from, to) {
		return axios.get(`/api/agreements?include=confirmed&from=${from}&to=${to}`);
	},
	loadDutyHistories(id) {
		return axios.post(`/api/changelogs/history`, { model: 'Duty', id: id });
	},
	loadUserDutyHistories(payload) {
		return axios.post(`/api/changelogs/history`, { model: 'Duty', user: payload.user, day: payload.day });
	},
	createAgreement(payload) {
		return axios.post('/api/agreements', payload);
	},
	exportRosterCsv(payload) {
		return axios.post('/api/roster/csv/export', payload);
	},
	exportRosterXlsx(payload) {
		return axios.post('/api/roster/xlsx/export', payload, { responseType: 'arraybuffer' });
	},
	updateDayStatus(dayId, status) {
		if (dayId) {
			return axios.patch(`/api/days/${dayId}`, status);
		}
		return axios.patch(`/api/days/`, status);
	},
	applyDefaultLabels(labels) {
		return axios.patch(`/api/duties/default-labels`, { labels });
	},
};
